import React, { forwardRef, useState, useMemo, useCallback, useRef } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { last, uniqBy, isEmpty, split } from 'lodash';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';

function VeracodeMappingForm({disableProjectFields = false, ...props}, ref) {

  const [mappedProjectList] = useState(() => {
    // this state contains the already mapped application
    // This is stored because the project are paginated
    // and if the option selected is not on 2st page, then the ID is displayed as this is how select works
    if (props.record) {
      const { applicationId, applicationName, appId } = props.record;
      const applicationIdArray = split(applicationId, ',');
      const applicationNameArray = split(applicationName, ',');
      const appIdArray = split(appId, ',');
      return {projectId: applicationIdArray.map((id, index) => ({id, name: applicationNameArray[index], otherProperties: { appId: appIdArray[index]}}))}
    }
    return { projectId: [] }
  })

  const optionsRef = useRef(mappedProjectList.projectId);

  const setOptionsFromPagination = (option) => {
    optionsRef.current = uniqBy([...optionsRef.current, ...option], 'id');
    // setOptions(prev => uniqBy([...prev,...option], 'id'));
  }

  const fetchRepos = useCallback((params) => {
    let { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, params);

    promise = promise.then((data) => {
      if(mappedProjectList["projectId"].length > 0 && !isEmpty(data.projects)){
          data.projects = [...data.projects, ...mappedProjectList["projectId"]];
      }
      const newProject = data.projects.map(project => {
        return {
          ...project,
          id: last(project.id.split('/'))
        }
      })
      setOptionsFromPagination(newProject);
      return data;
    }).catch(() => {
      message.error('Problem fetching applications');
    })
        
    return { promise, cancel }
  }, [props.toolName, mappedProjectList]);


  const getExtraFieldsData = (config) => {
    const { applicationId } = config;
  
    const data = optionsRef.current.reduce((acc, cv) => {
      const { id, name, otherProperties : { appId } } = cv;
      if(applicationId.includes(id)){
        acc.applicationId.push(id);
        acc.applicationName.push(name);
        acc.appId.push(appId)
      }
      return acc;
    },{applicationId: [], applicationName: [], appId: [] })
 
    return ({
      applicationId: data.applicationId.join(','),
      applicationName: data.applicationName.join(','),
      appId: data.appId.join(','),
      //send the property received in config
      ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id })
    });
  }

  const parseExtraFieldsDataFromResponse = useCallback((config) => {
    return ({
      applicationId: config.applicationId.split(','),
      //send the property received in config
      ...(config.discovery_config_id && { discovery_config_id: config.discovery_config_id })
    });
  }, []);

  const extraFields = useMemo(() => ([
    {
      name: 'applicationId',
      colSpan: '12',
      label: 'Application',
      type: FieldTypes.SELECT_WITH_PAGINATED_DATA,
      disabled: disableProjectFields,
      required: true,
      props: {
        mode:"multiple",
        api: fetchRepos,
        apiParams: {login_id: props.loginConfigId},
        autoFocus: !disableProjectFields
      }
    },
  ]), [fetchRepos, props.loginConfigId, disableProjectFields]);

  return (
    <GenericMappingForm
      {...props}
      ref={ref}
      parseExtraFieldsDataFromResponse={parseExtraFieldsDataFromResponse}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
    />
  )
}

export default forwardRef(VeracodeMappingForm)
